import { Injectable } from '@angular/core';
import { AuthUser } from '../models/auth-user.model';

const CURRENT_USER_KEY = 'com.tm.iam.currentUser';

@Injectable({ providedIn: 'root' })
export class StorageService {
  getCurrentUser(): AuthUser | null {
    const raw = localStorage.getItem(CURRENT_USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AuthUser;
    } catch {
      return null;
    }
  }

  setCurrentUser(user: AuthUser | null): void {
    if (user) {
      localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(CURRENT_USER_KEY);
    }
  }
}
